import React from "react";
import { Outlet } from "react-router-dom";

function AuthMain() {
  return (
    <div className=" w-full h-screen overflow-hidden">
      <Outlet />
    </div>
  );
}

export default AuthMain;
